export const FETCH_LIST_CATEGORY_SUCCESS = "FETCH_LIST_CATEGORY_SUCCESS";
export const FETCH_DETAIL_CATEGORY_SUCCESS = "FETCH_DETAIL_CATEGORY_SUCCESS";
export const FETCH_DELETE_DETAIL_CATEGORY_SUCCESS =
  "FETCH_DELETE_DETAIL_CATEGORY_SUCCESS";
